export default __webpack_public_path__ + "static/cow-a95f831a8c15992ce2eb4775ca5303d9.png";